var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4203_186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C4.9122 0.5 3.84884 0.822569 2.94437 1.42692C2.0399 2.03126 1.33495 2.89025 0.918665 3.89524C0.502383 4.90023 0.393465 6.0061 0.605683 7.073C0.817902 8.13989 1.34173 9.1199 2.11092 9.88909C2.8801 10.6583 3.86011 11.1821 4.92701 11.3943C5.9939 11.6065 7.09977 11.4976 8.10476 11.0813C9.10975 10.6651 9.96874 9.96011 10.5731 9.05564C11.1774 8.15117 11.5 7.0878 11.5 6C11.4983 4.54184 10.9183 3.14389 9.88719 2.11281C8.85611 1.08174 7.45816 0.50172 6 0.5ZM6 10.5C5.10999 10.5 4.23996 10.2361 3.49994 9.74161C2.75992 9.24715 2.18314 8.54434 1.84254 7.72208C1.50195 6.89981 1.41284 5.99501 1.58647 5.12209C1.7601 4.24918 2.18869 3.44736 2.81802 2.81802C3.44736 2.18868 4.24918 1.7601 5.1221 1.58647C5.99501 1.41283 6.89981 1.50195 7.72208 1.84254C8.54434 2.18314 9.24715 2.75991 9.74162 3.49993C10.2361 4.23996 10.5 5.10998 10.5 6C10.4987 7.19307 10.0241 8.33689 9.18052 9.18052C8.33689 10.0241 7.19307 10.4987 6 10.5ZM9 6C9 6.13261 8.94732 6.25979 8.85356 6.35355C8.75979 6.44732 8.63261 6.5 8.5 6.5H6C5.86739 6.5 5.74022 6.44732 5.64645 6.35355C5.55268 6.25979 5.5 6.13261 5.5 6V3C5.5 2.86739 5.55268 2.74021 5.64645 2.64645C5.74022 2.55268 5.86739 2.5 6 2.5C6.13261 2.5 6.25979 2.55268 6.35356 2.64645C6.44732 2.74021 6.5 2.86739 6.5 3V5.5H8.5C8.63261 5.5 8.75979 5.55268 8.85356 5.64645C8.94732 5.74021 9 5.86739 9 6Z",
    fill: "#fff",
    fillOpacity: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4203_186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.693479959f1f04f83794ebc5b2ff7925.svg";
export { ForwardRef as ReactComponent };